let _domainApi = null;
let _deepstreamApi = null;
let _printerApi = null;
let _apmApi = null;
let _services = null;
let _name = null;
let _fullstory = null;
let _domainUrl = null;
let _sguDomain = null;
let _config;

try {
  _config = JSON.parse(global.window.localStorage.config);
  _fullstory = _config.fullstory;
  _services = _config.services;
  _name = _config.name;
  _domainUrl = _config.domainUrl;
} catch {
  _config = null;
}

if (global.window.localStorage.domains) {
  const domains = JSON.parse(global.window.localStorage.domains);

  const domain = module => {
    let url = domains.api[module];
    return url || `${domains.api.default}/${module}`;
  };

  domain.toString = () => {
    return domains.api.default;
  };

  _domainApi = domain;
  _deepstreamApi = domains.deepstream;
  _printerApi = domains.printer;
  _apmApi = domains.apm;
  _sguDomain = domains.sgu;
} else {
  _domainApi = global.window.localStorage.domainApi;
  _deepstreamApi = global.window.localStorage.apiDeepstream;
}

export const apiDomain = _domainApi;
export const apiDeepstream = _deepstreamApi;
export const apiPrinter = _printerApi;
export const apiApm = _apmApi;
export const services = _services;
export const name = _name;
export const sguDomain = _sguDomain;
export const fullstory = _fullstory;
export const domainUrl = _domainUrl;
